import { apiFetch, apiFetchFormData } from './client';

export const postAPI = {
  getPending: () => apiFetch('/posts/pending'),

  getAll: () => apiFetch('/posts'),

  getByStatus: (status) => apiFetch(`/posts/status/${status}`),

  getByKeyword: (keywordId) => apiFetch(`/posts/keyword/${keywordId}`),

  getPendingByAccount: (accountId) =>
      apiFetch(`/posts/pending/account/${accountId}`),

  getByAccount: (accountId) =>
      apiFetch(`/posts/account/${accountId}`),

  update: (postId, data) =>
      apiFetch(`/posts/${postId}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),

  uploadImage: (postId, file) =>
      apiFetchFormData(`/posts/${postId}/upload-image`, file),

  regenerateImage: (postId, data) =>
      apiFetch(`/posts/${postId}/regenerate-image`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  regenerateCaption: (postId, data) =>
      apiFetch(`/posts/${postId}/regenerate-caption`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  create: (data) =>
      apiFetch('/posts/create', {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  generateSingle: (data) =>
      apiFetch('/posts/generate-single', {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  delete: (postId) =>
      apiFetch(`/posts/${postId}`, { method: 'DELETE' }),

  // 미디어 관리
  uploadMedia: (postId, file) =>
      apiFetchFormData(`/posts/${postId}/media`, file),

  generateMedia: (postId, data) =>
      apiFetch(`/posts/${postId}/media/generate`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  addMediaFromLibrary: (postId, imageUrl) =>
      apiFetch(`/posts/${postId}/media/from-library`, {
        method: 'POST',
        body: JSON.stringify({ imageUrl }),
      }),

  deleteMedia: (postId, mediaId) =>
      apiFetch(`/posts/${postId}/media/${mediaId}`, { method: 'DELETE' }),

  reorderMedia: (postId, mediaIds) =>
      apiFetch(`/posts/${postId}/media/reorder`, {
        method: 'PUT',
        body: JSON.stringify({ mediaIds }),
      }),

  replaceMedia: (postId, mediaId, file) =>
      apiFetchFormData(`/posts/${postId}/media/${mediaId}`, file, 'PUT'),
};

export const uploadAPI = {
  uploadNews: (newsId, accountId) =>
      apiFetch(`/upload/news/${newsId}/account/${accountId}`, { method: 'POST' }),

  uploadAllPending: () =>
      apiFetch('/upload/pending', { method: 'POST' }),

  uploadPendingByAccount: (accountId) =>
      apiFetch(`/upload/pending/account/${accountId}`, { method: 'POST' }),
};

export const keywordAPI = {
  create: (keywordData) =>
      apiFetch('/keywords', {
        method: 'POST',
        body: JSON.stringify(keywordData),
      }),

  getAll: ({ page = 0, size = 20, sort = 'createdAt', direction = 'desc' } = {}) =>
      apiFetch(`/keywords?page=${page}&size=${size}&sort=${sort}&direction=${direction}`),

  search: ({ q, isActive, page = 0, size = 20 } = {}) => {
    let url = `/keywords/search?q=${encodeURIComponent(q)}&page=${page}&size=${size}`;
    if (isActive !== null && isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }
    return apiFetch(url);
  },

  getById: (id) => apiFetch(`/keywords/${id}`),

  getByAccountId: (accountId) => apiFetch(`/keywords/account/${accountId}`),

  getActive: () => apiFetch('/keywords/active'),

  update: (id, keywordData) =>
      apiFetch(`/keywords/${id}`, {
        method: 'PUT',
        body: JSON.stringify(keywordData),
      }),

  toggle: (id) =>
      apiFetch(`/keywords/${id}/toggle`, { method: 'PATCH' }),

  delete: (id) =>
      apiFetch(`/keywords/${id}`, { method: 'DELETE' }),
};

export const imageUploadAPI = {
  upload: async (files, accountId, keyword = '') => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (accountId) formData.append('accountId', accountId);
    if (keyword) formData.append('keyword', keyword);

    const response = await fetch(`/api/images/upload`, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    });

    const data = await response.json();
    if (data.success) return data;
    throw new Error(data.message || '업로드 실패');
  },

  getUploaded: (accountId) =>
      apiFetch(`/images/uploaded?accountId=${accountId}`),
};

export const imageLibraryAPI = {
  getMyImages: (accountId, source) =>
      apiFetch(`/images/library?accountId=${accountId}${source ? `&source=${source}` : ''}`),
  toggleFavorite: (imageId) =>
      apiFetch(`/images/library/${imageId}/favorite`, { method: 'PATCH' }),
  deleteImage: (imageId) =>
      apiFetch(`/images/library/${imageId}`, { method: 'DELETE' }),
  getQuota: (accountId) =>
      apiFetch(`/images/library/quota?accountId=${accountId}`),
};

export const geminiAPI = {
  generate: (keyword, count = 1, accountId) =>
      apiFetch('/gemini/generate', {
        method: 'POST',
        body: JSON.stringify({ keyword, count, accountId }),
      }),
};
